import axios, { AxiosResponse } from 'axios';

export type Review = {
  blurb: string;
  date: string;
  name: string;
  rating: number;
  state: string;
  wholeReview: string;
};

export type ReviewEntry = {
  id: number;
  attributes: Review;
};

const strapiUri = `${process.env.CARVANA_APP_API_BASE}/stc/cms/api`;

const getCustomerReviews = async (): Promise<AxiosResponse<{ data: ReviewEntry[] }>> =>
  axios.get(`${strapiUri}/customer-reviews`);

export { getCustomerReviews };
